(function () {
  if (customElements.get('collection-showcase')) return;

  class CollectionShowcase extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.activePopup = null;
    }

    connectedCallback() {
      this.columnsDesktop = parseInt(this.dataset.columnsDesktop, 10) || 3;
      this.productGap = parseInt(this.dataset.productGap, 10) || 0;

      this.track = this.querySelector('.ai-collection-showcase__products-track');
      this.prevButton = this.querySelector('[data-carousel-prev]');
      this.nextButton = this.querySelector('[data-carousel-next]');
      this.products = this.querySelectorAll('.ai-collection-showcase__product');

      if (!this.track || this.products.length === 0) return;

      this.setupCarousel();
      this.setupQuickAdd();
      this.updateButtons();

      window.addEventListener('resize', () => {
        this.currentIndex = 0;
        this.updateCarousel();
      });

      document.addEventListener('click', (e) => {
        if (this.activePopup && !e.target.closest('.ai-collection-showcase__quick-add-popup') && !e.target.closest('[data-quick-add-trigger]')) {
          this.closeActivePopup();
        }
      });
    }

    setupCarousel() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.prev());
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.next());
      }
    }

    setupQuickAdd() {
      const triggers = this.querySelectorAll('[data-quick-add-trigger]');

      triggers.forEach((trigger) => {
        const popup = trigger.parentElement.querySelector('[data-quick-add-popup]');
        const closeButton = popup.querySelector('[data-popup-close]');
        const variantSelector = popup.querySelector('[data-variant-selector]');
        const quickAddForm = popup.querySelector('[data-quick-add-form]');
        const variants = JSON.parse(trigger.dataset.productVariants);

        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          if (this.activePopup && this.activePopup !== popup) {
            this.closeActivePopup();
          }

          if (popup.classList.contains('active')) {
            popup.classList.remove('active');
            this.activePopup = null;
          } else {
            this.renderVariants(variants, variantSelector, quickAddForm);
            popup.classList.add('active');
            this.activePopup = popup;
          }
        });

        if (closeButton) {
          closeButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            popup.classList.remove('active');
            this.activePopup = null;
          });
        }

        if (quickAddForm) {
          quickAddForm.addEventListener('submit', (e) => {
            e.preventDefault();
            this.addToCart(quickAddForm);
          });
        }
      });
    }

    updateCartCount() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((cart) => {
          document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
            const visible = bubble.querySelector('span[aria-hidden="true"]');
            if (visible) visible.textContent = cart.item_count;
          });
        })
        .catch(() => {});
    }

    addToCart(form) {
      const idInput = form.querySelector('input[name="id"]');
      const addBtn = form.querySelector('.ai-collection-showcase__popup-add-button');
      if (!idInput || !idInput.value || (addBtn && addBtn.disabled)) return;

      const original = addBtn ? addBtn.textContent : '';
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Adding…';
      }

      const drawer = document.querySelector('cart-drawer');
      const sections = drawer ? ['cart-drawer', 'cart-icon-bubble'] : undefined;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: Number(idInput.value),
          quantity: 1,
          sections: sections,
          sections_url: window.location.pathname,
        }),
      })
        .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
        .then(({ ok, data }) => {
          if (!ok) throw new Error(data && data.description ? data.description : 'Error');
          if (addBtn) addBtn.textContent = 'Added ✓';
          this.closeActivePopup();
          // Open + refresh the native cart drawer if present, else just bump count.
          if (drawer && data.sections) {
            drawer.renderContents(data);
          } else {
            this.updateCartCount();
          }
          setTimeout(() => {
            if (addBtn) {
              addBtn.textContent = original;
              addBtn.disabled = false;
            }
          }, 1300);
        })
        .catch(() => {
          form.submit();
        });
    }

    closeActivePopup() {
      if (this.activePopup) {
        this.activePopup.classList.remove('active');
        this.activePopup = null;
      }
    }

    renderVariants(variants, variantSelector, quickAddForm) {
      if (variants.length === 0) return;

      const optionNames = [];
      if (variants[0].option1) optionNames.push('option1');
      if (variants[0].option2) optionNames.push('option2');
      if (variants[0].option3) optionNames.push('option3');

      const optionValues = {};
      optionNames.forEach((optionName) => {
        optionValues[optionName] = [...new Set(variants.map((v) => v[optionName]))];
      });

      let html = '';
      optionNames.forEach((optionName, index) => {
        const optionLabel = `Option ${index + 1}`;
        html += `
          <div class="ai-collection-showcase__variant-selector">
            <label class="ai-collection-showcase__variant-label">
              ${optionLabel}: <span data-selected-value-${index}>${optionValues[optionName][0]}</span>
            </label>
            <div class="ai-collection-showcase__variant-options">
        `;

        optionValues[optionName].forEach((value) => {
          const isFirst = value === optionValues[optionName][0];
          const uniqueId = `${optionName}-${value}-${Date.now()}-${Math.random()}`;
          html += `
            <div class="ai-collection-showcase__variant-option">
              <input
                type="radio"
                name="${optionName}"
                value="${value}"
                id="${uniqueId}"
                class="ai-collection-showcase__variant-radio"
                data-option-index="${index}"
                ${isFirst ? 'checked' : ''}
              >
              <label
                for="${uniqueId}"
                class="ai-collection-showcase__variant-button"
              >
                ${value}
              </label>
            </div>
          `;
        });

        html += `
            </div>
          </div>
        `;
      });

      variantSelector.innerHTML = html;

      const radios = variantSelector.querySelectorAll('input[type="radio"]');
      radios.forEach((radio) => {
        radio.addEventListener('change', () => {
          const optionIndex = radio.dataset.optionIndex;
          const selectedValueSpan = variantSelector.querySelector(`[data-selected-value-${optionIndex}]`);
          if (selectedValueSpan) {
            selectedValueSpan.textContent = radio.value;
          }
          this.updateSelectedVariant(variants, variantSelector, quickAddForm);
        });
      });

      this.updateSelectedVariant(variants, variantSelector, quickAddForm);
    }

    updateSelectedVariant(variants, variantSelector, quickAddForm) {
      const selectedOptions = {};
      const radios = variantSelector.querySelectorAll('input[type="radio"]:checked');

      radios.forEach((radio) => {
        selectedOptions[radio.name] = radio.value;
      });

      const selectedVariant = variants.find((variant) => {
        return Object.keys(selectedOptions).every((key) => {
          return variant[key] === selectedOptions[key];
        });
      });

      if (selectedVariant) {
        const hiddenInput = quickAddForm.querySelector('input[name="id"]');
        if (hiddenInput) {
          hiddenInput.value = selectedVariant.id;
        } else {
          const newInput = document.createElement('input');
          newInput.type = 'hidden';
          newInput.name = 'id';
          newInput.value = selectedVariant.id;
          quickAddForm.insertBefore(newInput, quickAddForm.firstChild);
        }
      }
    }

    getColumns() {
      return window.innerWidth <= 989 ? 2 : this.columnsDesktop;
    }

    getMaxIndex() {
      const columns = this.getColumns();
      return Math.max(0, this.products.length - columns);
    }

    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.updateCarousel();
      }
    }

    next() {
      const maxIndex = this.getMaxIndex();
      if (this.currentIndex < maxIndex) {
        this.currentIndex++;
        this.updateCarousel();
      }
    }

    updateCarousel() {
      const productWidth = this.products[0].offsetWidth;
      const offset = this.currentIndex * (productWidth + this.productGap);

      this.track.style.transform = `translateX(-${offset}px)`;
      this.updateButtons();
    }

    updateButtons() {
      const maxIndex = this.getMaxIndex();

      if (this.prevButton) {
        this.prevButton.disabled = this.currentIndex === 0;
      }

      if (this.nextButton) {
        this.nextButton.disabled = this.currentIndex >= maxIndex;
      }
    }
  }

  customElements.define('collection-showcase', CollectionShowcase);
})();
